import { useEffect, useRef, useState } from "react";
import React from "react";

interface IProps {}

export interface IVideoControllerReturn {
  counter: number;
  isPlaying: boolean;
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>;
  isMuted: boolean;
  setIsMuted: React.Dispatch<React.SetStateAction<boolean>>;
  video: HTMLVideoElement | null; // setVideo: React.Dispatch<React.SetStateAction<HTMLVideoElement | null>>;
  setRefVideo: (it: HTMLVideoElement | null) => void;
}

export const VideoController = (props: IProps): IVideoControllerReturn => {
  //states
  const [counter, setCounter] = useState<number>(0);
  const [isPlaying, setIsPlaying] = useState<boolean>(true);
  useEffect(() => {
    try {
      if (!isPlaying) setCounter(counter + 1);
    } catch (e) {}
  }, [isPlaying]);

  const [isMuted, setIsMuted] = useState<boolean>(true);

  //refs
  //let refVideo: HTMLVideoElement | null = null;
  const setRefVideo = (it: HTMLVideoElement | null) => {
    if (it == null) return;
    setVideo(it);
    //it.autoplay = true;
  };
  const [video, setVideo] = useState<HTMLVideoElement | null>(null);
  useEffect(() => {
    if(video != null) video!!.autoplay = true;
    //Hint: setTimeout -> video == nul in Brave
    // setTimeout(() => {
    //   try {
    //     if (video != null) video!!.autoplay = true;
    //     //video!!.autoplay = true;
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }, 6000);
  }, [video]);

  //init
  //useEffect(() => {}, []);

  return {
    counter,
    isPlaying,
    setIsPlaying,
    isMuted,
    setIsMuted,
    //refs
    video,
    setRefVideo,
  };
};
